<template>
    <button
        class="flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center border-none bg-transparent p-0 text-theme-text"
        :aria-label="isPlaying ? 'Pause' : 'Play'"
        @click="$emit('toggle')"
    >
        <svg-icon :icon="isPlaying ? 'outline-pause-24px' : 'baseline-play_arrow-24px'" width="20px" height="20px" />
    </button>
</template>

<script>
/**
 * Play/Pause button for TTS players.
 * Emits 'toggle' event when clicked.
 */
export default {
    name: 'TtsPlayButton',
    props: {
        isPlaying: {
            type: Boolean,
            required: true,
        },
    },
    emits: ['toggle'],
};
</script>
